<div
  #container
  tabindex="-1"
  class="fixed top-0 left-0 right-0 z-50 hidden w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full"
  role="dialog"
  aria-modal="true"
  aria-labelledby="copy-schedules-title"
  (keydown.escape)="close()"
>
  <div class="relative w-97.75 max-h-full rounded-lg" cdkTrapFocus [cdkTrapFocusAutoCapture]="shown()">
    <form novalidate class="relative bg-primary-purple-light-2 rounded-lg shadow p-6" (ngSubmit)="onSubmit()">
      <section class="flex items-center">
        <h2 id="copy-schedules-title" class="w-full text-xl font-bold text-primary-purple">
          {{ literalService.get('setup.modal.copySchedules.title', true) }}
        </h2>
        <button
          type="button"
          class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg w-8 h-8 ml-auto inline-flex shrink-0 justify-center items-center focus-visible:outline-2 focus-visible:outline-primary-purple"
          [attr.aria-label]="literalService.get('close', true)"
          (click)="close()"
        >
          <img [src]="images.close" alt="" aria-hidden="true" class="h-6 w-6" />
        </button>
      </section>
      <p class="mt-4 text-base">{{ summary() }}</p>
      <fieldset class="mt-6">
        <legend class="flex items-center gap-1.5 mb-3 text-base text-primary-purple">
          <img [src]="images.setup.calendar" alt="" aria-hidden="true" class="h-6 w-6" />
          {{ literalService.get('setup.modal.copySchedules.targetDays', true) }}
        </legend>
        <div class="grid grid-cols-2 gap-x-4 gap-y-2.5">
          @for (day of dayOptions(); track day.id) {
            <label [for]="'copy-schedules-day-' + day.id" class="flex items-center gap-2 text-base" [class.cursor-pointer]="!day.isSource" [class.text-neutrals-grey-04]="day.isSource">
              <input
                #dayCheckbox
                type="checkbox"
                class="checkbox checkbox-sm"
                [id]="'copy-schedules-day-' + day.id"
                [checked]="day.checked"
                [disabled]="day.isSource"
                (change)="toggleTargetDay(day.id, dayCheckbox.checked)"
              />
              <span>{{ day.label }}</span>
              @if (day.isSource) {
                <span class="text-sm">({{ literalService.get('setup.modal.copySchedules.source', false) }})</span>
              }
            </label>
          }
        </div>
      </fieldset>
      <fieldset class="mt-6">
        <legend class="mb-3 text-base text-primary-purple">
          {{ literalService.get('setup.modal.copySchedules.existingSchedules', true) }}
        </legend>
        <div class="flex flex-col gap-2.5">
          <label for="copy-schedules-add" class="flex items-center gap-2 text-base cursor-pointer">
            <input id="copy-schedules-add" type="radio" name="copy-schedules-mode" class="radio radio-xs" [checked]="!replaceExisting()" (change)="replaceExisting.set(false)" />
            <span>{{ literalService.get('setup.modal.copySchedules.add', true) }}</span>
          </label>
          <label for="copy-schedules-replace" class="flex items-center gap-2 text-base cursor-pointer">
            <input id="copy-schedules-replace" type="radio" name="copy-schedules-mode" class="radio radio-xs" [checked]="replaceExisting()" (change)="replaceExisting.set(true)" />
            <span>{{ literalService.get('setup.modal.copySchedules.replace', true) }}</span>
          </label>
        </div>
      </fieldset>
      <section class="flex justify-between items-center mt-8">
        <button type="button" class="secondary gap-4 p-2 border-2 font-semibold h-10 w-full uppercase cursor-pointer mr-1 bg-white" (click)="close()">
          {{ literalService.get('cancel', true) }}
        </button>
        <button type="submit" class="primary gap-4 p-2 border-2 font-semibold h-10 w-full uppercase cursor-pointer ml-1" [disabled]="targetDays().length === 0">
          {{ literalService.get('setup.modal.copySchedules.copy', true) }}
        </button>
      </section>
    </form>
  </div>
</div>
